import { FC } from "react";
import Text from "../../../../components/Text";
import { DeleteV2Icon, EditV2Icon } from "../../../../assets/img/icons";

import styles from "./styles.module.scss";
import { deleteTag } from "../../../../services/api/admin/tags";
import { toast } from "react-toastify";
import IconButton from "../../../../components/IconButton";

type Props = {
    id: string;
    name: string;
    onEdit?: () => void;
    onDelete?: () => void;
};

const Tag: FC<Props> = ({ id, name, onEdit, onDelete }) => {
    const handleOnEdit = () => {
        if (onEdit) {
            onEdit();
        }
    };

    const handleOnDelete = () => {
        deleteTag(id).then(() => {
            toast.success("Tag supprimé avec succès !");
            if (onDelete) {
                onDelete();
            }
        });
    };

    return (
        <div className={styles.tag_container}>
            <Text variant="subtitle">{name}</Text>
            <div className={styles.actions}>
                <IconButton
                    size="medium"
                    icon={EditV2Icon}
                    color="secondary"
                    onClick={handleOnEdit}
                />
                <IconButton
                    size="medium"
                    icon={DeleteV2Icon}
                    color="secondary"
                    onClick={handleOnDelete}
                />
            </div>
        </div>
    );
};

export default Tag;
